import * as React from "react";
const SvgFiRrCarGarage = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-car-garage_svg__a)">
      <path
        fill="#062147"
        d="M23.892 6.454a1 1 0 0 1-1.346.437l-8.793-4.49a4.02 4.02 0 0 0-3.517.006l-8.78 4.48a1 1 0 1 1-.91-1.782L9.338.623a6.04 6.04 0 0 1 5.31-.007l8.807 4.493a1 1 0 0 1 .436 1.345m-1.814 6.666A7 7 0 0 1 23 16.594V18a4 4 0 0 1-2 3.463V22a2 2 0 0 1-4 0H7a2 2 0 1 1-4 0v-.537A4 4 0 0 1 1 18v-1.406c.001-1.218.319-2.416.922-3.474l2.058-3.6A5.01 5.01 0 0 1 8.321 7h7.359a5.01 5.01 0 0 1 4.34 2.52zM3.723 14h16.555l-1.993-3.488A3.01 3.01 0 0 0 15.68 9H8.32a3.01 3.01 0 0 0-2.6 1.512zm17.278 2.594Q21 16.296 20.964 16h-1.963v1a1 1 0 0 1-2 0v-1H7v1a1 1 0 1 1-2 0v-1H3.035a5 5 0 0 0-.036.594V18a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-car-garage_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCarGarage;
